import React from "react"
import PropTypes from "prop-types"

import ToggleButton from '../../form_sections/ToggleButton';
import StandardModal from '../../app_components/StandardModal'

class IdVerificationFilter extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      needVerifyModal: false,
      needVerify: true,
      selected: false,
      loaded: false
    }
    this.needVerifyModal = this.needVerifyModal.bind(this)
    this.selectIdVerification = this.selectIdVerification.bind(this)

  }

  componentDidMount() {
    this.setState({
      selected: this.props.idVerification != null && this.props.selected,
      needVerify: this.props.idVerification === null,
      loaded: true
    })
  }

  // componentDidUpdate() {
  //   if(this.state.selected != this.props.selected) {
  //     this.setState({
  //       selected: this.props.selected
  //     })
  //   }
  // }

  selectIdVerification() {
     if(this.state.needVerify) {
        this.props.toggleProModal('id')
     }
     // else if (!this.props.idVerification.isVerfied) {
     //    this.setState({
     //      needVerifyModal: true
     //    })
     // }
     else {
      //is verified -> update user
      this.props.toggleIdVerification()
      this.setState({
        selected: !this.state.selected
      })
    }

  }

  needVerifyModal() {
    return(
      <StandardModal onClose={() => this.setState({needVerifyModal: false})}>
        <h3 className="sectionText" style={{padding: 15}}>You need to finish, or update, your verification to use this filter.</h3>
        <button className="button_primary" onClick={() => window.location.replace('/verify_identity_steps')}>Finish Id Verification</button>
      </StandardModal>)
  }

  render() {
    if(!this.state.loaded) {
      return null
    }
    return(
      <div className="filterSection">
        {this.state.needVerifyModal && this.needVerifyModal()}
        <div style={{display: 'flex', flexDirection: ''}}>
          <h4 className="sectionHeader">ID Verification</h4>
          <h4 className="proHeader" style={{paddingLeft: 15}}>Pro Filter</h4>
        </div>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <ToggleButton
            selected={this.state.selected}
            pro={true}
            onClick={() => this.selectIdVerification()}
            buttonText="Verified Connects Only"
          />
        </div>
      </div>
    )
  }
}


export default IdVerificationFilter;
